// @ts-check

/* @enum {string} */
export const StudioStatus = {
	CANCELLED: 'CANCELLED',
	PENDING: 'PENDING',
	PLANNED: 'PLANNED',
	RUNNING: 'RUNNING',
	STOPPED: 'STOPPED',
};

/* @enum {string} */
export const StudioState = {
	CANCELLED: 'CANCELLED',
	ONGOING: 'ONGOING',
	NOT_STARTED: 'NOT_STARTED',
	TERMINATED: 'TERMINATED',
};

/**
 * @param {string} status
 * @returns {boolean}
 */
export const isStatusActive = (status) => (
	status === StudioStatus.RUNNING
	|| status === StudioStatus.PENDING
);

export const generatePassword = (length) => {
	let password = '';
	while (password.length < length) {
		password += Math.floor(Math.random() * 10);
	}
	return password;
};
